import Title from '@/components/Title/index.vue';
import Card from '@/components/Card/index.vue';
export default {
  name: 'function',
  components: {
    Title,
    Card
  },
  data() {
    return {
      functionList: [{
        title: '资讯内容',
        desc: '落地或者API形式，提供同花顺资讯、特色资讯内容、第三方版权的资讯内容。',
        img: require('@/assets/images/service/information/pctmn-news.png')
      }, {
        title: '资讯组件',
        desc: '云组件或者云API形式，覆盖不同场景的资讯应用需求，7*24快讯、个股资讯、综合资讯频道等组件。',
        img: require('@/assets/images/service/information/mobtmn-open.png')
      }, {
        title: '资讯中台',
        desc: '提供资讯接入、处理、打标签、推荐和触达的全流程管理。并提供采集、打标、智能写稿等云端资讯处理能力。',
        img: require('@/assets/images/service/information/mobtmn-data.png')
      }]
    };
  }
};